import Error from "../messagesModal/error";
import Success from "../messagesModal/success";

export default class BaseActions {
  constructor(dispatch, actionsSite, baseService, profile) {
    this.dispatch = dispatch;
    this.actionsSite = actionsSite;
    this.baseService = baseService;
    this.profile = profile;
  }

  saveConfirmation = (row, afterCallback) => {
    const configModal = {
      msg: `Você confirma a atualização do registro?`,
      title: `Atenção`,
      actions: [
        {
          label: "Sim",
          color: "success",
          callback: this.putData,
          arg: row,
          afterCallback,
          isSendingData: true,
        },
      ],
    };

    this.dispatch(this.actionsSite.setModal(configModal));
  };

  saveToggleClient = (row, afterCallback) => {
    const msg = row.status ? `Você confirma o bloqueio do cliente: "${row.companyName}"? Essa ação fará o bloqueio dos usuário vinculados, e exclusão dos Tokens de API. NÃO PODE SER DESFEITO!` : 'Você confirma o desbloqueio?';
    const configModal = {
      msg,
      title: `Atenção`,
      actions: [
        {
          label: "Sim",
          color: "success",
          callback: row.status ? this.inactiveClient : this.reactiveClient ,
          arg: row,
          afterCallback,
          isSendingData: true,
        },
      ],
    };

    this.dispatch(this.actionsSite.setModal(configModal));
  };

  inactiveClient = async (row, afterCallback) => {
    const url = `${this.baseService.route}/inactive/${row._id}`;
    const res = await this.baseService._get(url);
    
    const configModal = {
      component: res.error ? (
        <Error msg={res.msg} />
      ) : (
        <Success msg={res.msg} />
      ),
      title: res.error ? `Erro` : `Sucesso`,
    };
    this.dispatch(this.actionsSite.setModal(configModal));
    if (afterCallback) afterCallback();
  };

  reactiveClient = async (row, afterCallback) => {
    const url = `${this.baseService.route}/reactive/${row._id}`;
    const res = await this.baseService._get(url);
    
    const configModal = {
      component: res.error ? (
        <Error msg={res.msg} />
      ) : (
        <Success msg={res.msg} />
      ),
      title: res.error ? `Erro` : `Sucesso`,
    };
    this.dispatch(this.actionsSite.setModal(configModal));
    if (afterCallback) afterCallback();
  };

  putData = async (row, afterCallback) => {
    const url = `${this.baseService.route}/${row._id}`;
    const res = await this.baseService._put(url, row.newData);
    if (res.err && res.err.includes("E11000")) {
      res.msg = `Ocorreu um erro de email duplicado '${row.newData.email}'`;
    }
    const configModal = {
      component: res.error ? (
        <Error msg={res.msg} />
      ) : (
        <Success msg={res.msg} />
      ),
      title: res.error ? `Erro` : `Sucesso`,
    };
    this.dispatch(this.actionsSite.setModal(configModal));
    if (afterCallback) afterCallback();
  };

  toggleStatus = (row, afterCallback) => {
    row.newData = { status: !row.status };
    this.saveConfirmation(row, afterCallback);
  };

  toggleStatusClient = (row, afterCallback) => {
    this.saveToggleClient(row, afterCallback);
  };

  deleteConfirmationUser = (row, afterCallback) => {
    const configModal = {
      msg: `Deseja excluir o usuário ${row.name}?`,
      title: `Atenção`,
      actions: [
        {
          label: "Sim",
          color: "success",
          callback: this.deleteRow,
          arg: row,
          afterCallback,
          isSendingData: true,
        },
      ],
    };

    this.dispatch(this.actionsSite.setModal(configModal));
  };

  deleteConfirmation = (row, afterCallback) => {
    const configModal = {
      msg: `Deseja excluir o registro?`,
      title: `Atenção`,
      actions: [
        {
          label: "Sim",
          color: "success",
          callback: this.deleteRow,
          arg: row,
          afterCallback,
          isSendingData: true,
        },
      ],
    };

    this.dispatch(this.actionsSite.setModal(configModal));
  };

  deleteConfirmationClient = (row, afterCallback) => {
    const configModal = {
      msg: `Você confirma a exclusão do cliente: "${row.companyName}"? Essa ação fará a exclusão dos usuário vinculados, e exclusão dos Tokens de API. NÃO PODE SER DESFEITO!`,
      title: `Atenção`,
      actions: [
        {
          label: "Sim",
          color: "success",
          callback: this.deleteRowClient,
          arg: row,
          afterCallback,
          isSendingData: true,
        },
      ],
    };

    this.dispatch(this.actionsSite.setModal(configModal));
  };

  deleteRow = async (row, afterCallback) => {
    const res = await this.baseService.delete(row._id);
    const configModal = {
      component: res.error ? (
        <Error msg={res.msg} />
      ) : (
        <Success msg={res.msg} />
      ),
      title: res.error ? `Erro` : `Sucesso`,
    };
    this.dispatch(this.actionsSite.setModal(configModal));
    if (afterCallback) afterCallback();
  };

  deleteRowClient = async (row, afterCallback) => {
    const url = `${this.baseService.route}/remove/${row._id}`;
    const res = await this.baseService._get(url);
    const configModal = {
      component: res.error ? (
        <Error msg={res.msg} />
      ) : (
        <Success msg={res.msg} />
      ),
      title: res.error ? `Erro` : `Sucesso`,
    };
    this.dispatch(this.actionsSite.setModal(configModal));
    if (afterCallback) afterCallback();
  };

  isUserClient() {
    return this.profile.group?.type === "user";
  };

  isRootAdm() {
    return this.profile.group?.type === "root";
  };

  isRootClient() {
    return this.profile.group?.type === "adm";
  };

  isWhiteLabel() {
    return this.profile.client.isWhiteLabel;
  };

  isLevelZero() {
    return this.profile.client.level === 0;
  }

  isWhiteLabelLevelZero() {
    return this.isWhiteLabel() && this.isLevelZero();
  };

  haveClients() {
    return (this.isWhiteLabel() && this.isRootClient()) || this.isRootAdm()
  }

  isBillingTypePre() {
    return this.profile.client.billing.type === "pre";
  };

  sendEmail = async ({ data, type, whiteLabel=null }) => {
    const payload = {
      type,
      data,
      whiteLabelInfos: whiteLabel
    };
    const res = await this.baseService._post(`helper/send-email`, payload);
    const msg = res.msg ?? res.messages.join(", ");
    const configModal = {
      component: res.error ? <Error msg={msg} /> : <Success msg={msg} />,
      title: res.error ? `Erro` : `Sucesso`,
    };
    this.dispatch(this.actionsSite.setModal(configModal));
  };

  setCustomActions = (actions, customActions) => {
    for(let c of customActions){
        if (c.position){
            if(c.replace){
                actions.splice(c.position, 1);
                actions.splice(c.position, 0, c);
            } else {
                actions.splice(c.position, 0, c);
            }
            
        } else {
            actions.push(c);
        }
    }
  }

  getWhiteLabelInfos = async (id) => {
    const url = `user/white-label/by-user/${id}`;
    const res = await this.baseService._get(url);
    return res;
  }

  getWhiteLabelInfosByLogged = async () => {
    const url = `user/white-label/by-user-logged`;
    const res = await this.baseService._get(url);
    return res;
  }
}
